import React, { useState, useEffect }from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard'; 
import FeedIcon from '@mui/icons-material/Feed';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next" 
import { useDispatch } from "react-redux"; 
import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify'; 
import { TodayIs } from 'components/utils/TodayIs';    
import { resetFormatDIAction } from "actions/FormatDIActions";
import { resetLoginAction } from "actions/LoginActions.jsx";  
import ImportScript from 'components/utils/ImportScript';
import Footer from './Footer';
import Alerts from 'pages/alerts/Alerts.jsx';
import Messages from 'pages/messages/Messages';
import Login from "pages/login/LoginForm";
import GeneralSettings from 'pages/settings/GeneralSettings';
import EndpointSettings from "pages/endpoints/EndpointSettings";
import UserSettings from "pages/users/UserSettings";
import RolesUserSettings from "pages/roles/RolesUserSettings";
import ReasonTypeSettings from "pages/settings/ReasonTypeSettings";
import StatusTypeSettings from "pages/settings/StatusTypeSettings";
import SendEMAILSettings from "pages/settings/SendEMAILSettings";
import SendEmailsList from "pages/sendemails/SendEmailList";

const Home = () => {

    const {t,i18n} = useTranslation(['sidebar']); 
    const dispatch = useDispatch(); 
    const username = useSelector((state) => state.loginUser.username);
    const firstName = useSelector((state) => state.loginUser.firstName);  
    const lastName1 = useSelector((state) => state.loginUser.lastName1);  
    const lastName2 = useSelector((state) => state.loginUser.lastName2);  
    const email = useSelector((state) => state.loginUser.email);  
    const enabled = useSelector((state) => state.loginUser.enabled);  
    const aliasuser = useSelector((state) => state.loginUser.aliasuser);  
    const roles = useSelector((state) => state.loginUser.roles);  
    const defaultStore = useSelector((state) => state.loginUser.defaultStore);  
     
    const [indexShowSettings,setIndexShowSettings]=useState(0);
    const [showPrincipalMenu, setShowPrincipalMenu] = useState(true);
    const [showModalGeneralSettings, setShowModalGeneralSettings] = useState(false);
    const [showUserSettings,setShowModalUserSettings] = useState(false);
    const [showRolesUserSettings,setShowModalRolesUserSettings] = useState(false);
    const [showEndpointSettings,setShowModalEndpointSettings] = useState(false);
    const [showModalStatusTypeSettings, setShowModalStatusTypeSettings] = useState(false);
    const [showModalReasonTypeSettings, setShowModalReasonTypeSettings] = useState(false);
    const [showModalSendEmailsList, setShowModalSendEmailsList] = useState(false);
   
    const scriptUrl = '/js/sb-admin-2.min.js';
    function changeSelectedLanguage(){
        i18n.language==="es"?i18n.changeLanguage("en"):i18n.changeLanguage("es");
    };
  
    function logOut(){
        setIndexShowSettings(0);
        setShowPrincipalMenu(false);
        setShowModalGeneralSettings(false);
        setShowModalUserSettings(false);
        setShowModalRolesUserSettings(false);
        setShowModalEndpointSettings(false);
        setShowModalStatusTypeSettings(false); 
        setShowModalReasonTypeSettings(false); 
        setShowModalSendEmailsList(false); 
        dispatch(resetLoginAction()); 
        dispatch(resetFormatDIAction());
    };
     
    function openModalUsername(){
        setIndexShowSettings(0);
        setShowPrincipalMenu(false);
        setShowPrincipalMenu(false);
        setShowModalGeneralSettings(false);
        setShowModalUserSettings(true);
        setShowModalRolesUserSettings(false);
        setShowModalEndpointSettings(false);
        setShowModalStatusTypeSettings(false); 
        setShowModalReasonTypeSettings(false); 
        setShowModalSendEmailsList(false); 
    }

    function openModalRoleUser(){
        setIndexShowSettings(0);
        setShowPrincipalMenu(false);
        setShowModalGeneralSettings(false);
        setShowModalUserSettings(false);
        setShowModalRolesUserSettings(true);
        setShowModalEndpointSettings(false);
        setShowModalStatusTypeSettings(false); 
        setShowModalReasonTypeSettings(false);   
        setShowModalSendEmailsList(false); 
    }

    function openModalEndpoints(){
        setIndexShowSettings(0);
        setShowPrincipalMenu(false);
        setShowModalGeneralSettings(false);
        setShowModalUserSettings(false);
        setShowModalRolesUserSettings(false);
        setShowModalEndpointSettings(true);
        setShowModalStatusTypeSettings(false); 
        setShowModalReasonTypeSettings(false); 
        setShowModalSendEmailsList(false); 
    }

    function openModalSensEmailsList(){
        setIndexShowSettings(0);
        setShowPrincipalMenu(false);
        setShowModalGeneralSettings(false);
        setShowModalUserSettings(false);
        setShowModalRolesUserSettings(false);
        setShowModalEndpointSettings(false);
        setShowModalStatusTypeSettings(false); 
        setShowModalReasonTypeSettings(false); 
        setShowModalSendEmailsList(true); 
    } 
     
    function openModalGeneralSettings(){
        setShowModalGeneralSettings(!showModalGeneralSettings);
        setIndexShowSettings(0);
        setShowPrincipalMenu(false); 
        setShowModalUserSettings(false);
        setShowModalRolesUserSettings(false);
        setShowModalEndpointSettings(false);
        setShowModalStatusTypeSettings(false); 
        setShowModalReasonTypeSettings(false);
        setShowModalSendEmailsList(false); 
    }
    
    useEffect(
        () => {
            let isMounted = true;
                if (isMounted) {
                    switch (indexShowSettings) {
                        case 1:    
                        return setShowModalReasonTypeSettings(true);
                    case 2:    
                        return setShowModalStatusTypeSettings(true);
                    default:
                        return null;
                }
            }
            return()=>{ isMounted=false;}    
        },
        [indexShowSettings]
      ); 
    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer></ToastContainer>
        {(enabled===false || roles===undefined || roles[0]===undefined || roles[0].listmenus===undefined) ? <Login/>:
        <div id="page-top">

            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    <div className="sidebar-heading">
                        {t('Text_Interface')}
                    </div>

                    {/* Nav Item - Stores Collapse Menu */}
                       {/* Nav Item - Stores Collapse Menu */}
                       {roles[0].listmenus.find((key)=>(key.name==="Menu_Stores")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseStores"
                            aria-expanded="true" aria-controls="collapseStores">
                                <SettingsIcon/>
                                <span> {t('Menu_Stores')}</span>
                            </Link>
                            <div id="collapseStores" className="collapse" aria-labelledby="headingStores" data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Stores')}</h6>
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Stores_Stores")) &&
                                        <Link className="collapse-item"  to="/store">{t('SubMenu_Stores_Stores')} </Link>
                                    }
                                </div>
                            </div>
                        </li>
                    }

                     <li className="nav-item">
                        <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseSendEmails"
                        aria-expanded="true" aria-controls="collapseSendEmails">
                            <SettingsIcon/>
                            <span> {t('Menu_Emails')}</span>
                        </Link>
                        <div id="collapseSendEmails" className="collapse" aria-labelledby="headingStores" data-parent="#accordionSidebar">
                            <div className="bg-white py-2 collapse-inner rounded">
                                <h6 className="collapse-header">{t('Custom_Emails')}</h6>
                                <Link className="collapse-item"  to="/home" onClick={openModalSensEmailsList}>{t('SubMenu_Emails_Emails')} </Link> 
                            </div>
                        </div>
                    </li>
                        

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Sidebar - INFORMATION */}
                    <li className="nav-item active">
                        <Link className="nav-link" to="/home">
                            <FeedIcon/>
                            <span> {t('Text_Information')}</span>
                        </Link>
                    </li>
                    <div className="sidebar-heading">
                        {t('Text_User')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { username==='' ? t('Text_UserEmpty'): username}
                    </li>
                    <div className="sidebar-heading">
                        {t('Text_Alias')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { aliasuser==='' ? t('Text_AliasEmpty'): aliasuser}
                    </li>
                    <div className="sidebar-heading">
                        {t('Text_Name')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { firstName==='' ? t('Text_NameEmpty'): firstName+ ' '+ (lastName1===''?'':lastName1+' ')+ (lastName2===''?'':lastName2+' ')}
                    </li>

                    <div className="sidebar-heading">
                        {t('Text_Email')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { email==='' ? t('Text_EmailEmpty'): email}
                    </li>

                    <div className="sidebar-heading">
                        {t('Text_Role')}
                    </div>
                    {roles==null? t('Text_RoleEmpty'):roles.slice(0, 5).map((post) =>
                        <li className="sidebar-heading text-warning" key={post.id}>
                            {post.name}
                        </li>
                    )}
                   
                    <div className="sidebar-heading">
                        {t('Text_StoreSelected')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                    </li>
                    <br/>
                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    <div className="sidebar-heading">
                        {t('Text_Admin')}
                    </div>

                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span>{t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Settings"))&&
                                        <Link className="collapse-item"  to="/home" onClick={openModalGeneralSettings}>{t('SubMenu_Settings_Settings')} </Link> 
                                    }
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Users"))&&
                                        <Link className="collapse-item"  to="/home" onClick={openModalUsername}>{t('SubMenu_Settings_Users')} </Link>
                                    }
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Roles"))&&
                                        <Link className="collapse-item"  to="/home" onClick={openModalRoleUser}>{t('SubMenu_Settings_Roles')} </Link>
                                    }
                                    {roles[0].listmenus.find((key)=>(key.name==="Handle_Store_View_ENDPOINT"))&&
                                        <Link className="collapse-item"  to="/home" onClick={openModalEndpoints}>{t('SubMenu_Settings_Endpoints')} </Link>
                                    }
                                    <Link className="collapse-item" to="/home" onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                    <Link className="collapse-item" to="/home">{t('SubMenu_Settings_ChangePassword')}</Link>
                                </div>
                            </div>
                        </li> 
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/"  onClick={logOut}>
                            <LogoutIcon/>
                            <span>{t('Menu_LogOut')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>
 
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        
                        <ul className="navbar-nav ml-auto">
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="text-center">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>      
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>  
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}
                
                
                {/* Show Modals */}
             
                <GeneralSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    showModalGeneralSettings={showModalGeneralSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    indexShowSettings={indexShowSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                />

                <SendEMAILSettings  
                    showPrincipalMenu={showPrincipalMenu} 
                />
                 
                 <EndpointSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    showEndpointSettings={showEndpointSettings} 
                    setShowModalEndpointSettings={setShowModalEndpointSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                />

                <SendEmailsList  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    showModalSendEmailsList={showModalSendEmailsList} 
                    setShowModalSendEmailsList={setShowModalSendEmailsList}
                    setShowModalGeneralSettings={setShowModalGeneralSettings}  
                />
                
                <UserSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    showUserSettings={showUserSettings} 
                    setShowModalUserSettings={setShowModalUserSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                />
                <RolesUserSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    showRolesUserSettings={showRolesUserSettings} 
                    setShowModalRolesUserSettings={setShowModalRolesUserSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                />

                <ReasonTypeSettings  
                    showModalReasonTypeSettings={showModalReasonTypeSettings}
                    setShowModalReasonTypeSettings={setShowModalReasonTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings}  
                />

                <StatusTypeSettings  
                    showModalStatusTypeSettings={showModalStatusTypeSettings}
                    setShowModalStatusTypeSettings={setShowModalStatusTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings}  
                />
                 
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                    <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         


      </div>}
      {/* End of Body */}

    </>
  )
};

export default Home;
